import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { area } from 'd3-shape';
@Injectable()

export class UserService {
  constructor(private http: HttpClient) { }
   private pageNumber: number = 1;

  setPage(page: number) {
    this.pageNumber = page;
  }

  getPage() {
    return this.pageNumber;
  }

  //category
  createCategory(name: any, display_name: any, restricted: any) {
    var formData = {
      'valuename': name,
      'displayname': display_name,
      'restricted': restricted
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category`, formData).pipe(map(user => {
      return user;
    }));
  }

  getCategory(page: any, search: any, status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category?page=` + page + '&searchName=' + search + '&status=' + status).pipe(map(user => user));
  }

  getCategorybyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category/view/` + id).pipe(map(user => user));
  }

  updateCategory(id: any, name: any, display_name: any, status: any, restricted: any) {
    var formData = {
      'valuename': name,
      'displayname': display_name,
      'status': status,
      'restricted': restricted
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  deleteCategory(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  categoryStatusUpdate(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 1;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  //variant
  getVariant(page: any, search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant?page=` + page + '&searchName=' + search).pipe(map(user => user));
  }

  createVariant(name: any, group_id: any) {
    var formData = {
      'name': name,
      'group_id': group_id
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant`, formData).pipe(map(user => {
      return user;
    }));
  }

  getVariantbyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant/view/` + id).pipe(map(user => user));
  }

  getVariantGroup() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant-group`).pipe(map(user => user));
  }

  updateVariant(id: any, name: any, group_id: any, status: any) {
    var formData = {
      'name': name,
      'group_id': group_id,
      'status': status
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  deleteVariant(group_id: any, id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant/delete/` + group_id + '/' + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  variantStatusUpdate(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 1;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  //Addons
  getAllAddons(page: any, search: any, status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/add-on/getalladdons?page=` + page + '&searchName=' + search + '&status=' + status).pipe(map(user => user));
  }

  createAddons(name: any, display_name: any, status: any, showPrice: any, showAttribute: any, limit_type: any, min: any, max: any, values: any) {
    var formData = {
      'name': name,
      'displayname': display_name,
      'limitType': limit_type,
      'min': min,
      'max': max,
      'status': status,
      'showPrice': showPrice,
      'showAttribute': showAttribute,
      'value': values
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/add-on/addoncreatenew`, formData).pipe(map(user => {
      return user;
    }));
  }

  deleteAddons(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/add-on/deleteaddon/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  viewAllAddonsbyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/add-on/getparticularaddon/` + id).pipe(map(user => user));
  }

  updateAddons(id: any, name: any, display_name: any, status: any, showPrice: any, showAttribute: any, limit_type: any, min: any, max: any, values: any) {
    var formData = {
      'name': name,
      'displayname': display_name,
      'limitType': limit_type,
      'min': min,
      'max': max,
      'status': status,
      'showPrice': showPrice,
      'showAttribute': showAttribute,
      'value': values
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/add-on/updateaddon/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  //Assign-addons
  AllAddons(search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/add-on/all?searchName=` + search).pipe(map(user => user));
  }

  AllAvailableAddons(search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/add-on/all-avaliable?searchName=` + search).pipe(map(user => user));
  }

  AllCategory(search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category/all?searchName=` + search).pipe(map(user => user));
  }

  AllMenuItems() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/all`).pipe(map(user => user));
  }

  //Food Items
  getMenuItems(page: any, search: any, status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/getallmenu?page=` + page + '&searchName=' + search + '&status=' + status).pipe(map(user => user));
  }

  AllVariants(search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/variant/all?searchName=` + search).pipe(map(user => user));
  }

  getAllMenuImages(search: any,restaurant_id:any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/all-images?searchName=` + search + '&restaurant_id=' +restaurant_id).pipe(map(user => user));
  }

  createItem(name: any, display_name: any, status: any, shortCode: any,
    attribute: any, description: any, itemIn: any, categories: any, variants: any, addOns: any, item_price: any, customisable: any,
    variant_yes: any, variant_no: any, addon_yes: any, addon_no: any, discountType: any, discount: any, actualPrice: any,) {
    var formData = {
      'name': name,
      'displayname': display_name,
      'shortCode': shortCode,
      'attribute': attribute,
      'description': description,
      'status': status,
      'itemIn': itemIn,
      'categories': categories,
      'variants': variants,
      'addOns': addOns,
      'price': item_price,
      'customisable': customisable,
      'variants_yes': variant_yes,
      'variants_no': variant_no,
      'addOns_yes': addon_yes,
      'addOns_no': addon_no,
      'discountType': discountType,
      'discountPercentage': discount,
      'actualAmount': actualPrice
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/menucreatenew`, formData).pipe(map(user => {
      return user;
    }));
  }

  deleteMenu(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/deletemenu/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  viewMenubyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/getmenu/` + id).pipe(map(user => user));
  }

  viewMenubyIdNew(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/view-menu?menuId=` + id).pipe(map(user => user));
  }

  updateItem(id: any, name: any, display_name: any, status: any, shortCode: any,
    attribute: any, description: any, itemIn: any, categories: any, variants: any, addOns: any, item_price: any, customisable: any,
    variant_yes: any, variant_no: any, addon_yes: any, addon_no: any, discountType: any, discount: any, actualPrice: any,) {
    var formData = {
      'name': name,
      'displayname': display_name,
      'shortCode': shortCode,
      'attribute': attribute,
      'description': description,
      'status': status,
      'itemIn': itemIn,
      'categories': categories,
      'variants': variants,
      'addOns': addOns,
      'price': item_price,
      'customisable': customisable,
      'variants_yes': variant_yes,
      'variants_no': variant_no,
      'addOns_yes': addon_yes,
      'addOns_no': addon_no,
      'discountType': discountType,
      'discountPercentage': discount,
      'actualAmount': actualPrice
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/updatemenu/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  uploadImage(id: any, image: any, catalogimage: any) {
    const formData: FormData = new FormData();
    var type: any;
    if (image) {
      formData.append('image', image, image.name);
      type = 'image'
    } else {
      formData.append('image', catalogimage);
      type = 'url'
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/uploadmenuimage/` + id + '?uploadType=' + type, formData).pipe(map(user => {
      return user;
    }));
  }

  filterItembyCategory(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/by-category?categoryId=` + id).pipe(map(user => user));
  }

  filterItembyCategorypaginate(id: any, page: any, search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/by-category-paginate?categoryId=` + id + '&searchName=' + search + '&page=' + page).pipe(map(user => user));
  }


  // Dine-in 
  AllTables(search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/all?searchNumber=` + search).pipe(map(user => user));
  }

  AllAreas(search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/area/all?searchName=` + search).pipe(map(user => user));
  }

  AllAvailableAreas(search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/area/all-avaliable?searchName=` + search).pipe(map(user => user));
  }

  filtertablebyArea(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/area/listtablesforthearea/` + id).pipe(map(user => user));
  }

  AllpickupItems(page: any, status: any, pickupNo: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/listall?order_status=` + status + '&page=' + page + '&pickupNo=' + pickupNo).pipe(map(user => user));
  }

  pickupOrderCount(order_status: any, page: any, pickupNo: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/listall-count?order_status=` + order_status + '&page=' + page + '&pickupNo=' + pickupNo).pipe(map(user => user));
  }

  AllpickupItemsbypage(page: any, status: any, pickupNo: any, fromDate: any, toDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/listall-paginate?page=` + page + '&order_status=' + status + '&pickupNo=' + pickupNo + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => user));
  }

  AllMenuItemsbyItemIn(id: any, item: any, search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/menu/by-category-itemin?categoryId=` + id + '&searchItemIn=' + item + '&searchName=' + search).pipe(map(user => user));
  }

  setTax(areaId: any, area_type: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/tax/settax?areaId=` + areaId + '&area_type=' + area_type).pipe(map(user => user));
  }

  setCartTax(cartId: any, tax_id: any, tax_name: any, tax_value_type: any, tax_value_amount: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/setcarttax?cartId=` + cartId + '&tax_id=' + tax_id + '&tax_name=' + tax_name + '&tax_value_type=' + tax_value_type + '&tax_value_amount=' + tax_value_amount).pipe(map(user => user));
  }
  setPickupCartTax(cartId: any, tax_id: any, tax_name: any, tax_value_type: any, tax_value_amount: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/setcarttax?pickupId=` + cartId + '&tax_id=' + tax_id + '&tax_name=' + tax_name + '&tax_value_type=' + tax_value_type + '&tax_value_amount=' + tax_value_amount).pipe(map(user => user));
  }

  listAvailableTable(search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/all-avaliable?searchNumber=` + search).pipe(map(user => user));
  }

  switchTable(table_id: any, id: any) {
    var formData = {
      'table_id': table_id
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/switchtable/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  setcartStatus(cartId: any, table_status: any) {
    var formData = {
      'cartId': cartId,
      'table_status': table_status
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/setcartstatus`, formData).pipe(map(user => {
      return user;
    }));
  }

  setpickupcartStatus(cartId: any, table_status: any, paymentType: any) {
    var formData = {
      'pickupId': cartId,
      'pickup_status': table_status,
      'paymentType': paymentType
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/setcartstatus`, formData).pipe(map(user => {
      return user;
    }));
  }

  // Dine-in cart
  addtocart(table_id: any, menu_id: any, price: any, quantity: any) {
    var formData = {
      'table_id': table_id,
      'menu_id': menu_id,
      'price': price,
      'quantity': quantity
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/createcart`, formData).pipe(map(user => {
      return user;
    }));
  }

  addtocartNew(table_id: any, menus: any, total_price: any) {
    var formData = {
      'table_id': table_id,
      'menus': menus,
      'total_price': total_price,
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/createcart`, formData).pipe(map(user => {
      return user;
    }));
  }


  createCartNew(table_id: any, table_status: any, menu_id: any, menu_price: any, variant_id: any,
    addons: any, payment_status: any, tax_id: any, tax_name: any, tax_value_type: any, tax_value_amount: any,
    discount_id: any, discount_name: any, discount_value_type: any, discount_set_at: any, discount_value_amount: any, max_discount: any,
    container_price: any) {
    var formData = {
      'table_id': table_id,
      'table_status': table_status,
      'menu_id': menu_id,
      'menu_price': menu_price,
      'variant_id': variant_id,
      'addons': addons,
      'payment_status': payment_status,
      'tax_id': tax_id,
      'tax_name': tax_name,
      'tax_value_type': tax_value_type,
      'tax_value_amount': tax_value_amount,
      'discount_id': discount_id,
      'discount_name': discount_name,
      'discount_value_type': discount_value_type,
      'discount_set_at': discount_set_at,
      'discount_value_amount': discount_value_amount,
      'max_discount': max_discount,
      'container_price': container_price
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/createcart`, formData).pipe(map(user => {
      return user;
    }));
  }

  createpickupCartNew(table_id: any, table_status: any, menu_id: any, menu_price: any, variant_id: any,
    addons: any, payment_status: any, tax_id: any, tax_name: any, tax_value_type: any, tax_value_amount: any,
    discount_id: any, discount_name: any, discount_value_type: any, discount_set_at: any, discount_value_amount: any, max_discount: any,
    container_price: any) {
    var formData = {
      'pickup_no': table_id,
      'pickup_status': table_status,
      'menu_id': menu_id,
      'menu_price': menu_price,
      'variant_id': variant_id,
      'addons': addons,
      'payment_status': payment_status,
      'tax_id': tax_id,
      'tax_name': tax_name,
      'tax_value_type': tax_value_type,
      'tax_value_amount': tax_value_amount,
      'discount_id': discount_id,
      'discount_name': discount_name,
      'discount_value_type': discount_value_type,
      'discount_set_at': discount_set_at,
      'discount_value_amount': discount_value_amount,
      'max_discount': max_discount,
      'container_price': container_price
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/createcart?pickup_no=` + table_id, formData).pipe(map(user => {
      return user;
    }));
  }

  listcartItems() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/listallcarts`).pipe(map(user => user));
  }

  listcartItemsbyTableId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/listallcartsbytableid?table_id=` + id).pipe(map(user => user));
  }

  deletecart(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/deletecart/` + id).pipe(map(user => user));
  }

  updatecartQty(cartId: any, cartmenuId: any, quantity: any, tax_id: any, tax_value_type: any, tax_value_amount: any,
    discount_id: any, discount_value_type: any, discount_set_at: any, discount_value_amount: any, max_discount: any, container_price: any) {
    var formData = {
      'cartId': cartId,
      'cartmenuId': cartmenuId,
      'quantity': quantity,
      'tax_id': tax_id,
      'tax_value_type': tax_value_type,
      'tax_value_amount': tax_value_amount,
      'discount_id': discount_id,
      'discount_value_type': discount_value_type,
      'discount_set_at': discount_set_at,
      'discount_value_amount': discount_value_amount,
      'max_discount': max_discount,
      'container_price': container_price
    };
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/updatecartmenuquantity`, formData).pipe(map(user => user));
  }

  updatepickupcartQty(cartId: any, cartmenuId: any, quantity: any, tax_id: any, tax_value_type: any, tax_value_amount: any,
    discount_id: any, discount_value_type: any, discount_set_at: any, discount_value_amount: any, max_discount: any, container_price: any) {
    var formData = {
      'pickupId': cartId,
      'pickupmenuId': cartmenuId,
      'quantity': quantity,
      'tax_id': tax_id,
      'tax_value_type': tax_value_type,
      'tax_value_amount': tax_value_amount,
      'discount_id': discount_id,
      'discount_value_type': discount_value_type,
      'discount_set_at': discount_set_at,
      'discount_value_amount': discount_value_amount,
      'max_discount': max_discount,
      'container_price': container_price
    };
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/updatecartmenuquantity`, formData).pipe(map(user => user));
  }

  deletecartmenu(cartId: any, id: any, tax_id: any, tax_value_type: any, tax_value_amount: any,
    discount_id: any, discount_value_type: any, discount_set_at: any, discount_value_amount: any, max_discount: any, container_price: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/deletemenu?cartId=` + cartId + '&cartmenuId=' + id + '&tax_id=' + tax_id + '&tax_value_type=' + tax_value_type + '&tax_value_amount=' + tax_value_amount + '&discount_id=' + discount_id + '&discount_value_type=' + discount_value_type + '&discount_set_at=' + discount_set_at + '&discount_value_amount=' + discount_value_amount + '&max_discount=' + max_discount + '&container_price=' + container_price).pipe(map(user => user));
  }

  canceldineinCartMenu(cartId: any, cartmenuId: any, tax_id: any, tax_value_type: any, tax_value_amount: any,
    discount_id: any, discount_value_type: any, discount_set_at: any, discount_value_amount: any, max_discount: any, container_price: any, cancel_status: any, cancel_reason: any) {
    var formData = {
      'cartId': cartId,
      'cartmenuId': cartmenuId,
      'tax_id': tax_id,
      'tax_value_type': tax_value_type,
      'tax_value_amount': tax_value_amount,
      'discount_id': discount_id,
      'discount_value_type': discount_value_type,
      'discount_set_at': discount_set_at,
      'discount_value_amount': discount_value_amount,
      'max_discount': max_discount,
      'container_price': container_price,
      'cancel_status': cancel_status,
      'cancel_reason': cancel_reason
    };
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/cancelmenu`, formData).pipe(map(user => user));
  }

  deletepickupcartmenu(cartId: any, id: any, tax_id: any, tax_value_type: any, tax_value_amount: any,
    discount_id: any, discount_value_type: any, discount_set_at: any, discount_value_amount: any, max_discount: any, container_price: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/deletemenu?pickupId=` + cartId + '&pickupmenuId=' + id + '&tax_id=' + tax_id + '&tax_value_type=' + tax_value_type + '&tax_value_amount=' + tax_value_amount + '&discount_id=' + discount_id + '&discount_value_type=' + discount_value_type + '&discount_set_at=' + discount_set_at + '&discount_value_amount=' + discount_value_amount + '&max_discount=' + max_discount + '&container_price=' + container_price).pipe(map(user => user));
  }

  listcartItemsbycartTableId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/listallcartmenus?tableId=` + id).pipe(map(user => user));
  }
  listcartItemsbycartPickupId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/listallcartmenus?pickupId=` + id).pipe(map(user => user));
  }

  setCartDiscount(cartId: any, discount_id: any) {
    var formData = {
      'cartId': cartId,
      'discount_id': discount_id
    };
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/setcartdiscount`, formData).pipe(map(user => user));
  }

  setPickupCartDiscount(cartId: any, discount_id: any) {
    var formData = {
      'pickupId': cartId,
      'discount_id': discount_id
    };
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/setcartdiscount`, formData).pipe(map(user => user));
  }

  setCartContainer(cartId: any, container_price: any) {
    var formData = {
      'cartId': cartId,
      'container_price': container_price
    };
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/setcart-containerprice`, formData).pipe(map(user => user));
  }

  setPickupCartContainer(cartId: any, container_price: any) {
    var formData = {
      'pickupId': cartId,
      'container_price': container_price
    };
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/setcart-containerprice`, formData).pipe(map(user => user));
  }


  listallactivecategory(search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/category/active-all?searchName=` + search).pipe(map(user => user));
  }


  printdineInMenu(id: any, status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/viewmenu?tableId=` + id + '&status=' + status).pipe(map(user => user));
  }

  printpickupMenu(id: any, status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/viewmenu?pickupId=` + id + '&status=' + status).pipe(map(user => user));
  }

  printedSaveMenu(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/vieworder-save?tableId=` + id).pipe(map(user => user));
  }

  printedpickupSaveMenu(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/vieworder-save?pickupId=` + id).pipe(map(user => user));
  }

  addDineinInstruction(cartId: any, cartmenuId: any, description: any) {
    var formData = {
      'cartId': cartId,
      'cartmenuId': cartmenuId,
      'description': description
    };
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/updatecartmenudescription`, formData).pipe(map(user => user));
  }

  addPickupInstruction(pickupId: any, pickupmenuId: any, description: any) {
    var formData = {
      'pickupId': pickupId,
      'pickupmenuId': pickupmenuId,
      'description': description
    };
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/updatecartmenudescription`, formData).pipe(map(user => user));
  }


  // Dine-in Order
  orderDineIn(table_id: any, new_table_id: any, menu: any, total_price: any, orderstatus: any, status: any) {
    var formData = {
      'table_id': table_id,
      'new_table_id': new_table_id,
      'menu': menu,
      'total_price': total_price,
      'orderstatus': orderstatus,
      'status': status
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/order`, formData).pipe(map(user => {
      return user;
    }));
  }

  // Area
  addArea(area: any,) {
    var formData = {
      'area': area
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/area`, formData).pipe(map(user => {
      return user;
    }));
  }

  listAreaDetails(page: any, search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/area?page=` + page + '&searchName=' + search).pipe(map(user => user));
  }

  deleteArea(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/area/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  viewAllAreasbyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/area/view/` + id).pipe(map(user => user));
  }

  updateArea(id: any, area_name: any, status: any) {
    var formData = {
      'area_name': area_name,
      'status': status
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/area/update/` + id, formData).pipe(map(user => {
      return user;
    }));

  }


  listOfTablesName(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/area/listtablesforthearea/` + id).pipe(map(user => user));
  }

  //Table 
  listAllArea(search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/area/all?searchName=` + search).pipe(map(user => user));
  }


  addTable(id: any, tables: any) {
    var formData = {
      'table': tables
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  getTable(page: any, search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table?page=` + page + '&searchNumber=' + search).pipe(map(user => user));
  }

  deleteTable(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  viewTableById(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/view/` + id).pipe(map(user => user));
  }

  updateTable(id: any, table_number: any, no_of_people: any, status: any) {
    var formData = {
      // 'area_id': area_id,
      'table_number': table_number,
      'no_of_people': no_of_people,
      'status': status
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/update/` + id, formData).pipe(map(user => {
      return user;
    }));

  }

  listTableForAllAreas(search: any, page: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/area/listalltablesforalltheareas?searchName=` + search + '&page=' + page).pipe(map(user => user));
  }

  // Taxes
  createTax(tax_type: any, name: any, displayname: any, value_type: any, value_amount: any, status: any, description: any) {
    var formData = {
      'tax_type': tax_type,
      'name': name,
      'displayname': displayname,
      'value_type': value_type,
      'value_amount': value_amount,
      'description': description,
      'status': status
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/tax`, formData).pipe(map(user => {
      return user;
    }));
  }

  listTaxes(page: any, search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/tax?page=` + page + '&searchName=' + search).pipe(map(user => user));
  }

  viewTaxesbyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/tax/view/` + id).pipe(map(user => user));
  }

  updateTax(id: any, tax_type: any, name: any, displayname: any, value_type: any, value_amount: any, status: any, description: any) {
    var formData = {
      'tax_type': tax_type,
      'name': name,
      'displayname': displayname,
      'value_type': value_type,
      'value_amount': value_amount,
      'description': description,
      'status': status
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/tax/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  deleteTaxes(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/tax/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  // Discounts
  listDiscounts(page: any, search: any, status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/discount?page=` + page + '&searchName=' + search + '&status=' + status).pipe(map(user => user));
  }

  listAllDiscounts(search: any, type: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/discount/all?searchName=` + search + '&searchType=' + type).pipe(map(user => user));
  }

  listAvailableDiscounts(orderType: any, orderAmount: any, searchName: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/discount/avaliable?orderType=` + orderType + '&orderAmount=' + orderAmount + '&searchName=' + searchName).pipe(map(user => user));
  }


  createDiscounts(discount_on: any, title: any, value_type: any, set_at: any, value_amount: any, terms_conditions: any, order_type: any, applicable_on: any, applicableamount_from: any, applicableamount_to: any,
    max_discount: any, from_date: any, to_date: any, from_time: any, to_time: any, days: any, validation: any, status: any) {
    var formData = {
      'discount_on': discount_on,
      'title': title,
      'value_type': value_type,
      'set_at': set_at,
      'value_amount': value_amount,
      'terms_conditions': terms_conditions,
      'order_type': order_type,
      'applicable_on': applicable_on,
      'applicableamount_from': applicableamount_from,
      'applicableamount_to': applicableamount_to,
      'max_discount': max_discount,
      'from_date': from_date,
      'to_date': to_date,
      'from_time': from_time,
      'to_time': to_time,
      'days': days,
      'validation': validation,
      'status': status
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/discount`, formData).pipe(map(user => {
      return user;
    }));
  }

  viewDiscountbyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/discount/view/` + id).pipe(map(user => user));
  }

  deleteDiscount(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/discount/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  updateDiscounts(id: any, discount_on: any, title: any, value_type: any, set_at: any, value_amount: any, terms_conditions: any, order_type: any, applicable_on: any, applicableamount_from: any, applicableamount_to: any,
    max_discount: any, from_date: any, to_date: any, from_time: any, to_time: any, days: any, validation: any, status: any) {
    var formData = {
      'discount_on': discount_on,
      'title': title,
      'value_type': value_type,
      'set_at': set_at,
      'value_amount': value_amount,
      'terms_conditions': terms_conditions,
      'order_type': order_type,
      'applicable_on': applicable_on,
      'applicableamount_from': applicableamount_from,
      'applicableamount_to': applicableamount_to,
      'max_discount': max_discount,
      'from_date': from_date,
      'to_date': to_date,
      'from_time': from_time,
      'to_time': to_time,
      'days': days,
      'validation': validation,
      'status': status
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/discount/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  removeCartDiscount(id: any) {
    var formData = {
      "cartId": id
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/removecartdiscount`, formData).pipe(map(user => {
      return user;
    }));
  }

  removePickupCartDiscount(id: any) {
    var formData = {
      "pickupId": id
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/removecartdiscount`, formData).pipe(map(user => {
      return user;
    }));
  }

  //customer
  addCartCustomer(customer_name: any, customer_mobileno: any, customer_address: any) {
    var formData = {
      "customer_name": customer_name,
      "customer_mobileno": customer_mobileno,
      "customer_address": customer_address
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/customer-dinein`, formData).pipe(map(user => {
      return user;
    }));
  }



  getExistingCustomer(searchMobileNo: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/customer-dinein/all?searchMobileNo=` + searchMobileNo).pipe(map(user => user));
  }

  getCustomerPage(page: any, search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/customer-dinein?page=` + page + '&searchMobileNo=' + search).pipe(map(user => user));
  }

  setCartCustomer(cartId: any, customer_id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/setcartcustomer?cartId=` + cartId + '&customer_id=' + customer_id).pipe(map(user => user));
  }

  setPickupCartCustomer(cartId: any, customer_id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/setcartcustomer?pickupId=` + cartId + '&customer_id=' + customer_id).pipe(map(user => user));
  }

  releasetable(id: any, paymentType: any) {
    var formData = {
      "cartId": id,
      "paymentType": paymentType
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/setcarttobill`, formData).pipe(map(user => {
      return user;
    }));
  }

  deleteCustomer(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/customer-dinein/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  updateCartCustomer(id: any, customer_name: any, customer_mobileno: any, customer_address: any) {
    var formData = {
      "customer_name": customer_name,
      "customer_mobileno": customer_mobileno,
      "customer_address": customer_address
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/customer-dinein/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  //App user
  getAppUsers(page: any, searchMobileNo: any, blockStatus: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/customer-app?page=` + page + '&searchMobileNo=' + searchMobileNo + '&blockStatus=' + blockStatus).pipe(map(user => user));
  }

  blockAppuser(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 0;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/customer-app/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  unblockAppuser(id: any, status: any) {
    let apiStatus = status == 1 ? 1 : 1;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/customer-app/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  // Invoice
  getinvoice(page: any, searchOrderNo: any, fromDate: any, toDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/order?page=` + page + '&searchOrderNo=' + searchOrderNo + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => user));
  }

  viewinvoice(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/order/view?orderId=` + id).pipe(map(user => user));
  }

  viewInvoiceOrder(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/order/vieworder?orderId=` + id).pipe(map(user => user));
  }

  viewInvoiceMenu(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/order/viewmenu?orderId=` + id).pipe(map(user => user));
  }

  allinvoice(page: any, limit: any, search: any, fromDate: any, toDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/invoice/?page=` + page + '&limit=' + limit + '&search=' + search + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => user));
  }

  getPickupinvoice(page: any, searchPickupNo: any, fromDate: any, toDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup?page=` + page + '&searchPickupNo=' + searchPickupNo + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => user));
  }

  pickupInvoiceMenubyId(id: any, status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/viewmenu?pickupId=` + id + '&status=' + status).pipe(map(user => user));
  }

  pickupInvoiceOrderbyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/vieworder-save?pickupId=` + id).pipe(map(user => user));
  }

  downloadInvoice(fromDate: any, toDate: any, type: any) {
    const file = this.http.get<Blob>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/invoice/excel?fromDate=` + fromDate + '&toDate=' + toDate + '&type=' + type, { responseType: 'blob' as 'json' }).pipe(map(user => {
      return user
    }));
    return file;
  }

  // Delivery Boys
  createDeliveryBoy(full_name: any, mobile: any, email: any, date_of_birth: any, address: any, state: any, city: any, pincode: any,
    account_holder_name: any, bank_name: any, account_number: any, ifsc: any, image: any, aadhaar: any, pan: any, dl: any, rc: any) {
    const formData: FormData = new FormData();
    formData.append('full_name', full_name);
    formData.append('mobile', mobile);
    formData.append('email', email);
    formData.append('date_of_birth', date_of_birth);
    formData.append('address', address);
    formData.append('state', state);
    formData.append('city', city);
    formData.append('pincode', pincode);
    formData.append('account_holder_name', account_holder_name);
    formData.append('bank_name', bank_name);
    formData.append('account_number', account_number);
    formData.append('ifsc', ifsc);
    if (image) {
      formData.append('image', image, image.name);
    }
    if (aadhaar) {
      formData.append('aadhaar', aadhaar, aadhaar.name);
    }
    if (pan) {
      formData.append('pan', pan, pan.name);
    }
    if (dl) {
      formData.append('dl', dl, dl.name);
    }
    if (rc) {
      formData.append('rc', rc, rc.name);
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver`, formData).pipe(map(user => {
      return user;
    }));
  }

  listDeliveryBoys(page: any, search: any, blockStatus: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver?page=` + page + '&searchMobileNo=' + search + '&blockStatus=' + blockStatus).pipe(map(user => user));
  }

  updateDeliveryBoy(id: any, full_name: any, mobile: any, email: any, date_of_birth: any, address: any, state: any, city: any, pincode: any,
    account_holder_name: any, bank_name: any, account_number: any, ifsc: any, image: any, aadhaar: any, pan: any, dl: any, rc: any, workingStatus: any, status: any) {
    const formData: FormData = new FormData();
    formData.append('full_name', full_name);
    formData.append('mobile', mobile);
    formData.append('email', email);
    formData.append('date_of_birth', date_of_birth);
    formData.append('address', address);
    formData.append('state', state);
    formData.append('city', city);
    formData.append('pincode', pincode);
    formData.append('account_holder_name', account_holder_name);
    formData.append('bank_name', bank_name);
    formData.append('account_number', account_number);
    formData.append('ifsc', ifsc);
    if (image) {
      formData.append('image', image, image.name);
    }
    if (aadhaar) {
      formData.append('aadhaar', aadhaar, aadhaar.name);
    }
    if (pan) {
      formData.append('pan', pan, pan.name);
    }
    if (dl) {
      formData.append('dl', dl, dl.name);
    }
    if (rc) {
      formData.append('rc', rc, rc.name);
    }
    formData.append('workingStatus', workingStatus)
    formData.append('status', status)
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  deleteDeliveryBoy(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver/delete/` + id).pipe(map(user => {
      return user;
    }))
  }

  viewDeliveryBoy(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver/view/` + id).pipe(map(user => {
      return user;
    }))
  }
  viewGroceryDeliveryBoy(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/driver/view/` + id).pipe(map(user => {
      return user;
    }))
  }

  deliveryBoysStatusUpdate(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 1;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  blockdeliveryBoys(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 0;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  unblockdeliveryBoys(id: any, status: any) {
    let apiStatus = status == 1 ? 1 : 1;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  getdeliveryboyOrder(page: any, driverId: any, search: any, fromDate: any, toDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver/list-orders?page=` + page + '&driverId=' + driverId + '&search=' + search + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => {
      return user;
    }))
  }
  getGrocerydeliveryboyOrder(page: any, driverId: any, search: any, fromDate: any, toDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/driver/list-orders?page=` + page + '&driverId=' + driverId + '&search=' + search + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => {
      return user;
    }))
  }


  deliveryBoytotalcount(fromDate: any, toDate: any, driverId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver/totalcounts?fromDate=` + fromDate + '&toDate=' + toDate + '&driverId=' + driverId).pipe(map(user => {
      return user;
    }))
  }
  GrocerydeliveryBoytotalcount(fromDate: any, toDate: any, driverId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/driver/totalcounts?fromDate=` + fromDate + '&toDate=' + toDate + '&driverId=' + driverId).pipe(map(user => {
      return user;
    }))
  }



  //New Orders - Delivery

  getDeliveryOrders(order_status: any, orderId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/delivery/all?order_status=` + order_status + '&orderId=' + orderId).pipe(map(user => {
      return user;
    }))
  }

  getDeliveryAllCounts(status: any, orderId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/delivery/all-count?order_status=` + status + '&orderId=' + orderId).pipe(map(user => {
      return user;
    }))
  }

  getReservationOrders(order_status: any, reservationno: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/reservation/all?accepted_status=` + order_status + '&reservationNo=' + reservationno).pipe(map(user => {
      return user;
    }))
  }

  getReservationOrdersPaginate(accepted_status: any, reservationNo: any, page: any, fromDate: any, toDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/reservation/all-page?accepted_status=` + accepted_status + '&reservationNo=' + reservationNo + '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => {
      return user;
    }))
  }

  getReservationCancelledOrdersPaginate(reservationNo: any, page: any, fromDate: any, toDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/reservation/cancel-page?reservationNo=` + reservationNo + '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => {
      return user;
    }))
  }

  getDeliveryOrdersPage(order_status: any, orderId: any, page: any, fromDate: any, toDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/delivery/all-page?order_status=` + order_status + '&orderId=' + orderId + '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => {
      return user;
    }))
  }

  getDeliveryOrdersMenu(orderId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/delivery/viewmenu?orderId=` + orderId).pipe(map(user => {
      return user;
    }))
  }

  getDeliveryOrdersbyId(orderId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/delivery/vieworder?orderId=` + orderId).pipe(map(user => {
      return user;
    }))
  }

  getReservationOrdersMenu(orderId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/reservation/viewmenu?reservationId=` + orderId).pipe(map(user => {
      return user;
    }))
  }

  getReservationOrdersbyId(orderId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/reservation/vieworder?reservationId=` + orderId).pipe(map(user => {
      return user;
    }))
  }


  getPickupOrdersMenu(orderId: any, status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/viewmenu?pickupId=` + orderId + '&status=' + status).pipe(map(user => {
      return user;
    }))
  }

  getPickupOrdersbyId(orderId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/vieworder-save?pickupId=` + orderId).pipe(map(user => {
      return user;
    }))
  }
  updateOrderStatus(order_id: any, order_status: any,driverAssign:any) {
    var formData = {
      "order_id": order_id,
      "order_status": order_status,
      "driverAssign":driverAssign
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/delivery/update-order-status`, formData).pipe(map(user => {
      return user;
    }));
  }

  updateReservationOrderStatus(order_id: any, order_status: any) {
    var formData = {
      "reservation_id": order_id,
      "accepted_status": order_status
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/reservation/update-reservation-status`, formData).pipe(map(user => {
      return user;
    }));
  }

  allReservationOrderCount(reservationStatus: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/dashboard/activereservationcounts?reservationStatus=` + reservationStatus).pipe(map(user => user));
  }

  assigntable(order_id: any, table_id: any) {
    var formData = {
      "reservationId": order_id,
      "table_id": table_id
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/reservation/set-to-cart`, formData).pipe(map(user => {
      return user;
    }));
  }

  AssignDrivers(order_id: any, driver_id: any, accepted_status: any) {
    var formData = {
      "order_id": order_id,
      "driver_id": driver_id,
      "accepted_status": accepted_status
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/delivery/update-accepted-status`, formData).pipe(map(user => {
      return user;
    }));
  }

  AssignAllDrivers(order_id: any, assigned_driver: any) {
    var formData = {
      "order_id": order_id,
      "assigned_driver": assigned_driver
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/delivery/assign-drivers`, formData).pipe(map(user => {
      return user;
    }));
  }

  listAllDeliveryBoys(searchMobileNo: any, searchStatus: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver/all?searchMobileNo=` + searchMobileNo + '&searchStatus=' + searchStatus).pipe(map(user => user));
  }

  alldeliveryCount(order_status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/dashboard/activedeliverycounts?order_status=` + order_status).pipe(map(user => user));
  }

  // driver settlement
  setDriversettlement(driver_id: any, recipient_name: any, paid_amount: any) {
    var formData = {
      "driver_id": driver_id,
      "recipient_name": recipient_name,
      "paid_amount": paid_amount
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver-settlement`, formData).pipe(map(user => {
      return user;
    }));
  }

  getsettlementHistory(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver-settlement/all?driverId=` + id).pipe(map(user => {
      return user;
    }))
  }

  getsettlementHistorywithPage(id: any, page: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/driver-settlement?driverId=` + id + '&page=' + page).pipe(map(user => {
      return user;
    }))
  }
    getsettlementGroceryHistorywithPage(id: any, page: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/driver-settlement?driverId=` + id + '&page=' + page).pipe(map(user => {
      return user;
    }))
  }


  //Dashboard
  dashboardCount() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/dashboard/`).pipe(map(user => {
      return user;
    }))
  }

  dashboardChartdata(startDate: any, endDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/dashboard/daywisestats?startDate=` + startDate + '&endDate=' + endDate).pipe(map(user => {
      return user;
    }))
  }

  dashboardChartdataNew(startDate: any, endDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/dashboard/daywisechartdata?startDate=` + startDate + '&endDate=' + endDate).pipe(map(user => {
      return user;
    }))
  }

  dashboardPaymentCash(startDate: any, endDate: any, type: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/dashboard/payments-total?startDate=` + startDate + '&endDate=' + endDate + '&paymentType=' + type).pipe(map(user => {
      return user;
    }))
  }

  dashboardPaymentCashNew(startDate: any, endDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/dashboard/payments-total-all?startDate=` + startDate + '&endDate=' + endDate).pipe(map(user => {
      return user;
    }))
  }


  getrestaurantdetails() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/view`).pipe(map(user => user));
  }

  restarantuploadImage(image: any) {
    const formData: FormData = new FormData();
    if (image) {
      formData.append('image', image, image.name);
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/uploadimage`, formData).pipe(map(user => {
      return user;
    }));
  }


  // Settings - Staff
  getStaffUsers(page: any, status: any, searchName: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/staff?page=` + page + '&status=' + status + '&searchName=' + searchName).pipe(map(user => {
      return user;
    }))
  }

  createStaff(username: any, password: any, permissions: any) {
    const formData = {
      'username': username,
      'password': password,
      'permissions': JSON.stringify(permissions)
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/staff`, formData).pipe(map(user => {
      return user;
    }));
  }

  deleteStaffUser(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/staff/delete/` + id).pipe(map(user => {
      return user;
    }))
  }

  viewStaffUsersbyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/staff/view/` + id).pipe(map(user => {
      return user;
    }))
  }

  updateStaff(id: any, username: any, permissions: any, status: any) {
    const formData = {
      'username': username,
      //'password':password,
      'permissions': JSON.stringify(permissions),
      'status': status
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/staff/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  updatepassword(id: any, password: any) {
    const formData = {
      'password': password,
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/staff/update-password/` + id, formData).pipe(map(user => {
      return user;
    }));
  }


  blockStaffUser(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 0;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/staff/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  unblockStaffUser(id: any, status: any) {
    let apiStatus = status == 1 ? 1 : 1;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/staff/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  staffUserStatusUpdate(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 1;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/staff/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  getPermission() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/permissions`).pipe(map(user => {
      return user;
    }))
  }

  // delivery- QR code
  createQRcode(name: any, floor: any, areaname: any, type: any) {
    const formData = {
      'name': name,
      'floor': floor,
      'areaname': areaname,
      "type": type
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/qrCode/add`, formData).pipe(map(user => {
      return user;
    }));
  }

  getQRCode(page: any, searchName: any, type: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/qrCode/list?page=` + page + '&searchName=' + searchName + '&type=' + type).pipe(map(user => {
      return user;
    }))
  }

  deleteQRCode(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/qrCode/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  viewQRCodebyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/qrCode/view/` + id).pipe(map(user => {
      return user;
    }))
  }

  updateQRcode(id: any, name: any, floor: any, areaname: any, type: any) {
    const formData = {
      'name': name,
      'floor': floor,
      'areaname': areaname,
      'type': type
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/qrCode/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  // dineIn - QR Code
  getBlanktable(areaId: any, searchNumber: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/all-avaliable-by-area?areaId=` + areaId + '&searchNumber=' + searchNumber).pipe(map(user => {
      return user;
    }))
  }

  getAlltablebyArea(areaId: any, searchNumber: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/all-by-area?areaId=` + areaId + '&searchNumber=' + searchNumber).pipe(map(user => {
      return user;
    }))
  }

  createDineinQRcode(name: any, area_id: any, table_id: any, type: any) {
    const formData = {
      'name': name,
      'area_id': area_id,
      'table_id': table_id,
      "type": type
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/qrCode/add`, formData).pipe(map(user => {
      return user;
    }));
  }

  updateDineinQRcode(id: any, name: any, area_id: any, table_id: any, type: any) {
    const formData = {
      'name': name,
      'area_id': area_id,
      'table_id': table_id,
      "type": type
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/qrCode/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  // Kitchen
  getdineinKitchen(searchNumber: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/kitchen/all-table?searchNumber=` + searchNumber).pipe(map(user => {
      return user;
    }))
  }

  getDineinCounts(searchNumber: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/kitchen/all-table-count?searchNumber=` + searchNumber).pipe(map(user => {
      return user;
    }))
  }

  getdeliveryKitchen(searchNumber: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/kitchen/all-delivery?orderId=` + searchNumber).pipe(map(user => {
      return user;
    }))
  }

  getdeliveryKitchenCount(searchNumber: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/kitchen/all-delivery-count?orderId=` + searchNumber).pipe(map(user => {
      return user;
    }))
  }


  // Live Orders
  allLiveOrders(search: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/kitchen/all?searchNumber=` + search).pipe(map(user => user));
  }

  // Header Status
  headerStatusupdate(valueType: any, status: any) {
    let apiStatus = status == 0 ? 0 : 1;
    const formData = {
      'valueType': valueType,
      'status': apiStatus
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/force-status`, formData).pipe(map(user => user));
  }

  updateHeaderTime(valueType: any, fromtime: any, totime: any) {
    const formData = {
      'valueType': valueType,
      'fromtime': fromtime,
      'totime': totime
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/force-time`, formData).pipe(map(user => {
      return user;
    }));
  }

  // update gstin
  updateGSTIN(gstin: any) {
    var formData = {
      'gstin': gstin
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/update-gstin`, formData).pipe(map(user => {
      return user;
    }));
  }

  // dinein Notification
  getdineinNotification() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/dinein-notification`).pipe(map(user => user))
  }

  deletedineinNotification(id: any, type: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/dinein-notification/delete?id=` + id + '&type=' + type)
      .pipe(map((user) => {
        return user;
      }));
  }

  resetReorder(id: any) {
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/table/reset-reorder-status/` + id, {}).pipe(map(user => user))
  }

  // kot reprint
  dineinKotReprint(tableId: any, status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/cart/viewmenu?tableId=` + tableId + '&status=' + status).pipe(map(user => user))
  }

  pickupKotReprint(pickupId: any, status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/pickup/viewmenu?pickupId=` + pickupId + '&status=' + status).pipe(map(user => user))
  }

  // new count api's
  getNewDeliveryCount() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/dashboard/delivery-count`).pipe(map(user => user))
  }

  getNewPickupCount() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/dashboard/pickup-count`).pipe(map(user => user))
  }

  getNewReservationCount() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/dashboard/reservation-count`).pipe(map(user => user))
  }

  getNewKitchenCount() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/kitchen/all-count`).pipe(map(user => user))
  }

  getNewOrdersCount() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/dashboard/new-order-count`).pipe(map(user => user))
  }

  // Managers
  getAllManagers(page: any, status: any, searchName: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/manager?page=` + page + '&status=' + status + '&searchName=' + searchName).pipe(map(user => user))
  }

  viewManagerbyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/manager/view/` + id).pipe(map(user => user))
  }

  createManager(username: any, name: any, password: any) {
    var formData = {
      'username': username,
      'name': name,
      'password': password
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/manager`, formData).pipe(map(user => {
      return user;
    }));
  }

  updateManager(id: any, username: any, name: any, status: any) {
    var formData = {
      'username': username,
      'name': name,
      'status': status
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/manager/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  deleteManager(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/manager/delete/` + id).pipe(map(user => {
      return user;
    }))
  }

  updateManagerpassword(id: any, password: any) {
    const formData = {
      'password': password,
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/manager/update-password/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  blockManagerUser(id: any, status: any) {
    //let apiStatus = status == 0 ? 0 : 0;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/manager/update-status/` + id, { status: status }).pipe(map(user => user));
  }

  // Canteen Cart
  createCanteenCart(table_id: any, table_status: any, menu_id: any, menu_price: any, variant_id: any,
    addons: any, payment_status: any, tax_id: any, tax_name: any, tax_value_type: any, tax_value_amount: any,
    discount_id: any, discount_name: any, discount_value_type: any, discount_set_at: any, discount_value_amount: any, max_discount: any,
    container_price: any) {
    var formData = {
      //'pickup_no': table_id,
      'canteenorder_status': table_status,
      'menu_id': menu_id,
      'menu_price': menu_price,
      'variant_id': variant_id,
      'addons': addons,
      'payment_status': payment_status,
      'tax_id': tax_id,
      'tax_name': tax_name,
      'tax_value_type': tax_value_type,
      'tax_value_amount': tax_value_amount,
      'discount_id': discount_id,
      'discount_name': discount_name,
      'discount_value_type': discount_value_type,
      'discount_set_at': discount_set_at,
      'discount_value_amount': discount_value_amount,
      'max_discount': max_discount,
      'container_price': container_price
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen/createcart?canteenorder_no=` + table_id, formData).pipe(map(user => {
      return user;
    }));
  }

  listcartItemsbycartCanteenId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen/listallcartmenus?canteenorderId=` + id).pipe(map(user => user));
  }

  updateCanteencartQty(cartId: any, cartmenuId: any, quantity: any, tax_id: any, tax_value_type: any, tax_value_amount: any,
    discount_id: any, discount_value_type: any, discount_set_at: any, discount_value_amount: any, max_discount: any, container_price: any) {
    var formData = {
      'canteenorderId': cartId,
      'canteenordermenuId': cartmenuId,
      'quantity': quantity,
      'tax_id': tax_id,
      'tax_value_type': tax_value_type,
      'tax_value_amount': tax_value_amount,
      'discount_id': discount_id,
      'discount_value_type': discount_value_type,
      'discount_set_at': discount_set_at,
      'discount_value_amount': discount_value_amount,
      'max_discount': max_discount,
      'container_price': container_price
    };
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen/updatecartmenuquantity`, formData).pipe(map(user => user));
  }

  deleteCanteencartmenu(cartId: any, id: any, tax_id: any, tax_value_type: any, tax_value_amount: any,
    discount_id: any, discount_value_type: any, discount_set_at: any, discount_value_amount: any, max_discount: any, container_price: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen/deletemenu?canteenorderId=` + cartId + '&canteenordermenuId=' + id + '&tax_id=' + tax_id + '&tax_value_type=' + tax_value_type + '&tax_value_amount=' + tax_value_amount + '&discount_id=' + discount_id + '&discount_value_type=' + discount_value_type + '&discount_set_at=' + discount_set_at + '&discount_value_amount=' + discount_value_amount + '&max_discount=' + max_discount + '&container_price=' + container_price).pipe(map(user => user));
  }

  setCanteenCartCustomer(cartId: any, customer_id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen/setcartcustomer?canteenorderId=` + cartId + '&customer_id=' + customer_id).pipe(map(user => user));
  }

  addCanteenInstruction(canteenorderId: any, canteenordermenuId: any, description: any) {
    var formData = {
      'canteenorderId': canteenorderId,
      'canteenordermenuId': canteenordermenuId,
      'description': description
    };
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen/updatecartmenudescription`, formData).pipe(map(user => user));
  }

  setCanteencartStatus(cartId: any, table_status: any, paymentType: any) {
    var formData = {
      'canteenorderId': cartId,
      'canteenorder_status': table_status,
      'paymentType': paymentType
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen/setcartstatus`, formData).pipe(map(user => {
      return user;
    }));
  }

  printCanteenMenu(id: any, status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen/viewmenu?canteenorderId=` + id + '&status=' + status).pipe(map(user => user));
  }

  printedCanteenSaveMenu(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen/vieworder-save?canteenorderId=` + id).pipe(map(user => user));
  }

  setCanteenCartDiscount(canteenorderId: any, discount_id: any) {
    var formData = {
      'canteenorderId': canteenorderId,
      'discount_id': discount_id
    };
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen/setcartdiscount`, formData).pipe(map(user => user));
  }

  setCanteenContainer(canteenorderId: any, container_price: any) {
    var formData = {
      'canteenorderId': canteenorderId,
      'container_price': container_price
    };
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen/setcart-containerprice`, formData).pipe(map(user => user));
  }

  removeCanteenCartDiscount(id: any) {
    var formData = {
      "canteenorderId": id
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen/removecartdiscount`, formData).pipe(map(user => {
      return user;
    }));
  }

  getCanteenInvoiceOrdersPage(order_status: any, searchCanteenorderNo: any, page: any, fromDate: any, toDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen?searchCanteenorderNo=` + searchCanteenorderNo + '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => {
      return user;
    }))
  }

  setCanteenCartTax(cartId: any, tax_id: any, tax_name: any, tax_value_type: any, tax_value_amount: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/canteen/setcarttax?canteenorderId=` + cartId + '&tax_id=' + tax_id + '&tax_name=' + tax_name + '&tax_value_type=' + tax_value_type + '&tax_value_amount=' + tax_value_amount).pipe(map(user => user));
  }


  //grocery category
  creategroceryCategory(name: any, description: any, image: any) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    if (image) {
      formData.append('image', image, image.name);
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/category/create`, formData).pipe(map(user => {
      return user;
    }));
  }

  getgroceryCategory(page: any, search: any, status: any, storeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/category/list?page=` + page + '&search=' + search + '&status=' + status + '&storeId=' + storeId).pipe(map(user => user));
  }

  getgroceryCategorybyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/category/view/` + id).pipe(map(user => user));
  }

  updategroceryCategory(id: any, name: any, description: any, status: any) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    formData.append('status', status)
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/category/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  deletegroceryCategory(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/category/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  grocerycategoryStatusUpdate(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 1;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/category/update/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  getCategoryDropdown(status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/category/dropdown?status=` + status).pipe(map(user => user));
  }

  // Subcategory

  creategrocerySubCategory(name: any, description: any, categoryId: any, image: any) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    formData.append('categoryId', categoryId);
    if (image) {
      formData.append('image', image, image.name);
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/subCategory/create`, formData).pipe(map(user => {
      return user;
    }));
  }

  getgrocerysubCategory(page: any, search: any, status: any, categoryId: any, storeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/subCategory/list?page=` + page + '&search=' + search + '&status=' + status + '&categoryId=' + categoryId + '&storeId=' + storeId).pipe(map(user => user));
  }

  getgrocerysubCategorybyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/subCategory/view/` + id).pipe(map(user => user));
  }

  updategrocerysubCategory(id: any, name: any, description: any, categoryId: any, status: any) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    formData.append('categoryId', categoryId);
    formData.append('status', status)
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/subCategory/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  deletegrocerysubCategory(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/subCategory/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  grocerysubcategoryStatusUpdate(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 1;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/subCategory/update/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  getsubCategoryDropdown(status: any, categoryId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/subCategory/dropdown?status=` + status + '&categoryId=' + categoryId).pipe(map(user => user));
  }

  // UOM

  createUOM(name: any) {
    const formData = new FormData();
    formData.append('name', name);
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/uom/create`, formData).pipe(map(user => {
      return user;
    }));
  }

  getUOM(page: any, search: any, storeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/uom/list?page=` + page + '&search=' + search + '&storeId=' + storeId).pipe(map(user => user));
  }

  getUOMById(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/uom/getById/` + id).pipe(map(user => user));
  }

  updateUOM(id: any, name: any) {
    const formData = new FormData();
    formData.append('name', name);

    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/uom/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  getUOMDropdown() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/uom/dropdown`).pipe(map(user => user));
  }

  deleteUOM(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/uom/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }


  // Grocery Type

  createGroceryType(name: any, categoryId: any, subCategoryId: any) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('categoryId', categoryId);
    formData.append('subCategoryId', subCategoryId);
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/type/create`, formData).pipe(map(user => {
      return user;
    }));
  }

  getGroceryType(page: any, search: any, storeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/type/list?page=` + page + '&search=' + search + '&storeId=' + storeId).pipe(map(user => user));
  }

  getGroceryTypeById(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/type/getById/` + id).pipe(map(user => user));
  }

  updateGroceryType(id: any, name: any, categoryId: any, subCategoryId: any) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('categoryId', categoryId);
    formData.append('subCategoryId', subCategoryId);
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/type/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  getTypeDropdown(status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/type/dropdown?status=` + status).pipe(map(user => user));
  }

  deleteGroceryType(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/type/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  //grocery Brand
  creategroceryBrand(name: any, description: any, image: any) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    if (image) {
      formData.append('image', image, image.name);
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/brand/create`, formData).pipe(map(user => {
      return user;
    }));
  }

  getgroceryBrand(page: any, search: any, status: any, storeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/brand/list?page=` + page + '&search=' + search + '&status=' + status + '&storeId=' + storeId).pipe(map(user => user));
  }

  getgroceryBrandbyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/brand/view/` + id).pipe(map(user => user));
  }

  updategroceryBrand(id: any, name: any, description: any, status: any) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    formData.append('status', status)
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/brand/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  deletegroceryBrand(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/brand/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  groceryBrandStatusUpdate(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 1;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/brand/update/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  getBrandDropdown() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/brand/dropdown`).pipe(map(user => user));
  }

  // Property

  createGroceryProperty(name: any, categoryId: any, subCategoryId: any) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('categoryId', categoryId);
    formData.append('subCategoryId', subCategoryId);
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/properties/create`, formData).pipe(map(user => {
      return user;
    }));
  }

  getGroceryProperty(page: any, search: any, storeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/properties/list?page=` + page + '&search=' + search + '&storeId=' + storeId).pipe(map(user => user));
  }

  getGroceryPropertyById(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/properties/getById/` + id).pipe(map(user => user));
  }

  updateGroceryProperty(id: any, name: any, categoryId: any, subCategoryId: any) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('categoryId', categoryId);
    formData.append('subCategoryId', subCategoryId);
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/properties/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }
  getGroceryPropertyDropdown(status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/properties/dropdown?status=` + status).pipe(map(user => user));
  }
  deleteGroceryProperty(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/properties/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  // Grocery Item
  createGroceryItem(name: any, description: any, brandId: any, categoryId: any, subcategoryId: any,
    typeId: any, propertiesId: any, uomId: any, weight: any, tags: any, status: any, vendor: any, price: any, newToMarket: any, displayname: any, discountType: any, discount: any, actualPrice: any, productType: any, image: any,
    variants: any, customisable: any, variant_yes: any, variant_no: any, storeId: any) {
    const formData = new FormData();

    formData.append('name', name);
    formData.append('description', description);
    formData.append('brandId', brandId);
    formData.append('categoryId', categoryId);
    formData.append('subcategoryId', subcategoryId);
    formData.append('typeId', typeId);
    formData.append('propertiesId', propertiesId);
    formData.append('uomId', uomId);
    formData.append('weight', weight);
    formData.append('tags', JSON.stringify(tags));
    formData.append('status', status);
    formData.append('vendor', vendor);
    formData.append('price', price);
    formData.append('newToMarket', newToMarket);
    formData.append('displayname', displayname);
    formData.append('discountType', discountType);
    formData.append('discountPercentage', discount);
    formData.append('actualAmount', actualPrice);
    formData.append('productType', productType);
    formData.append('variants', JSON.stringify(variants));
    formData.append('customisable', customisable);
    formData.append('variants_yes', variant_yes);
    formData.append('variants_no', variant_no);
    formData.append('storeId', storeId);
    if (image) {
      if (image instanceof File) {
        formData.append('image', image, image.name);
      } else if (typeof image === 'string') {
        formData.append('image', image);
      }
    }

    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/items/create`, formData).pipe(map(user => {
      return user;
    }));
  }

  getgroceryItem(page: any, search: any, status: any, categoryId: any, subcatgeoryId: any, brandId: any, typeId: any, propertiesId: any, storeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/items/list?page=` + page + '&search=' + search + '&status=' + status + '&categoryId=' + categoryId + '&subcatgeoryId=' + subcatgeoryId + '&brandId=' + brandId + '&typeId=' + typeId + '&propertiesId=' + propertiesId + '&storeId=' + storeId).pipe(map(user => user));
  }

  getgroceryItembyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/items/getById/` + id).pipe(map(user => user));
  }
  AllGroceryVariants(search: any, storeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/variant/all?searchName=` + search + '&storeId=' + storeId).pipe(map(user => user));
  }
  groceryItemStatusUpdate(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 1;
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/items/updateStatus/` + id, { status: apiStatus }).pipe(map(user => user));
  }



  deletegroceryItem(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/items/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  updategroceryItem(id: any, name: any, description: any, brandId: any, categoryId: any, subcategoryId: any,
    typeId: any, propertiesId: any, uomId: any, weight: any, tags: any, status: any, vendor: any, price: any,
    newToMarket: any, displayname: any, discountType: any, discount: any, actualPrice: any, productType: any, image: any, variants: any, customisable: any, variant_yes: any, variant_no: any) {

    const formData = new FormData();

    formData.append('name', name);
    formData.append('description', description);
    formData.append('brandId', brandId);
    formData.append('categoryId', categoryId);
    formData.append('subcategoryId', subcategoryId);
    formData.append('typeId', typeId);
    formData.append('propertiesId', propertiesId);
    formData.append('uomId', uomId);
    formData.append('weight', weight);
    formData.append('tags', JSON.stringify(tags));
    formData.append('status', status);
    formData.append('vendor', vendor);
    formData.append('price', price);
    formData.append('newToMarket', newToMarket);
    formData.append('displayname', displayname);
    formData.append('discountType', discountType);
    formData.append('discountPercentage', discount);
    formData.append('actualAmount', actualPrice);
    formData.append('productType', productType);
    formData.append('variants', JSON.stringify(variants));
    formData.append('customisable', customisable);
    formData.append('variants_yes', variant_yes);
    formData.append('variants_no', variant_no);
    if (image) {
      if (image instanceof File) {
        formData.append('image', image, image.name);
      } else if (typeof image === 'string') {
        formData.append('image', image);
      }
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/items/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  // Grocery Order status

  getGroceryNewOrdersCount() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/order/count`).pipe(map(user => user))
  }

  getGroceryDeliveryOrders(orderStatus: any, search: any, page: any, fromDate: any, toDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/order/list?orderStatus=` + orderStatus + '&search=' + search + '&page=' + page + '&fromDate=' + fromDate + '&toDate=' + toDate).pipe(map(user => {
      return user;
    }))
  }

  updateGroceryOrderStatus(id: any, orderStatus: any,driverAssign:any) {
    var formData = {
      'orderStatus': orderStatus,
      'driverAssign':driverAssign
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/order/update-status/${id}`, formData).pipe(map(user => {
      return user;
    }));
  }
  getGroceryDeliveryOrdersbyId(orderId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/order/viewById/${orderId}`).pipe(map(user => {
      return user;
    }))
  }

  // discount
  DiscountCalculate(discountType: any, discount: any, actualPrice: any) {
    var formData = {
      'discountType': discountType,
      'discount': discount,
      'actualPrice': actualPrice
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/items/calulate-discount`, formData).pipe(map(user => {
      return user;
    }));
  }

  // delivery charges
  createDeliveryCharges(storeId: any, charges: any) {
    var formData = {
      'storeId': storeId,
      'charges': charges
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/deliveryCharges/create`, formData).pipe(map(user => {
      return user;
    }));
  }

  getDeliverycharges(storeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/deliveryCharges/view?storeId=` + storeId).pipe(map(user => user));
  }

  createFoodDeliveryCharges(restaurantId: any, charges: any) {
    var formData = {
      'restaurantId': restaurantId,
      'charges': charges
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/deliveryCharges/create`, formData).pipe(map(user => {
      return user;
    }));
  }

  getFoodDeliverycharges(restaurantId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/deliveryCharges/view?restaurantId=` + restaurantId).pipe(map(user => user));
  }
  getAllGroceryImages(search: any, storeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/items/all-images?search=` + search + '&storeId=' + storeId).pipe(map(user => user));
  }
  rejectedRestOrder(order_id: any) {
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/delivery/refundAmt/${order_id}`, {}).pipe(map(user => {
      return user;
    }));
  }
  rejectedGroceryOrder(order_id: any) {
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/order/refundAmt/${order_id}`, {}).pipe(map(user => {
      return user;
    }));
  }

  // Setting --Grocery
  getStaffGrocery(page: any, searchName: any, status: any, storeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/settings/staff?page=` + page + '&status=' + status + '&searchName=' + searchName + '&storeId=' + storeId).pipe(map(user => {
      return user;
    }))
  }

  createGroceryStaff(username: any, password: any, permissions: any) {
    const formData = {
      'username': username,
      'password': password,
      'permissions': JSON.stringify(permissions)
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/settings/staff`, formData).pipe(map(user => {
      return user;
    }));
  }

  deleteStaffGrocery(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/settings/staff/delete/` + id).pipe(map(user => {
      return user;
    }))
  }

  viewStaffGrocerybyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/settings/staff/view/` + id).pipe(map(user => {
      return user;
    }))
  }

  updateGroceryStaff(id: any, username: any, permissions: any, status: any) {
    const formData = {
      'username': username,
      //'password':password,
      'permissions': JSON.stringify(permissions),
      'status': status
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/settings/staff/update/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  updateGrocerypassword(id: any, password: any) {
    const formData = {
      'password': password,
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/settings/staff/update-password/` + id, formData).pipe(map(user => {
      return user;
    }));
  }


  blockStaffGrocery(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 0;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/settings/staff/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  unblockStaffGrocery(id: any, status: any) {
    let apiStatus = status == 1 ? 1 : 1;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/settings/staff/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  staffGroceryStatusUpdate(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 1;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/settings/staff/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }

  getGroceryPermission() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/settings/permissions`).pipe(map(user => {
      return user;
    }))
  }

  AssignGroceryDrivers(order_id: any, driver_id: any, accepted_status: any) {
    var formData = {
      "order_id": order_id,
      "driver_id": driver_id,
      "accepted_status": accepted_status
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/order/update-accepted-status`, formData).pipe(map(user => {
      return user;
    }));
  }


  AssignAllGroceryDrivers(order_id: any, assigned_driver: any) {
    var formData = {
      "order_id": order_id,
      "assigned_driver": assigned_driver
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/order/assign-drivers`, formData).pipe(map(user => {
      return user;
    }));
  }

  // grocery upload image
  groceryCategoryUploadImage(id: any, image: any, uploadType: any) {
    const formData: FormData = new FormData();
    if (image) {
      formData.append('image', image, image.name);
    }
    formData.append('uploadType', uploadType)
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/category/uploadImage/` + id, formData).pipe(map(user => user))
  }
  grocerysubCategoryUploadImage(id: any, image: any, uploadType: any) {
    const formData: FormData = new FormData();
    if (image) {
      formData.append('image', image, image.name);
    }
    formData.append('uploadType', uploadType)
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/subCategory/uploadImage/` + id, formData).pipe(map(user => user))
  }
  groceryBarndUploadImage(id: any, image: any, uploadType: any) {
    const formData: FormData = new FormData();
    if (image) {
      formData.append('image', image, image.name);
    }
    formData.append('uploadType', uploadType)
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/brand/uploadImage/` + id, formData).pipe(map(user => user))
  }

  // grocery variant
  getGroceryVariant(page: any, search: any, storeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/variant?page=` + page + '&searchName=' + search + '&storeId=' + storeId).pipe(map(user => user));
  }

  createGroceryVariant(name: any) {
    var formData = {
      'name': name
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/variant`, formData).pipe(map(user => {
      return user;
    }));
  }

  getGroceryVariantbyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/variant/view/` + id).pipe(map(user => user));
  }

  getGroceryVariantGroup() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/variant-group`).pipe(map(user => user));
  }

  updateGroceryVariant(id: any, storeId: any, name: any, status: any) {
    var formData = {
      'name': name,
      'status': status
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/variant/update/${id}?storeId=${storeId}`, formData).pipe(map(user => {
      return user;
    }));
  }

  deleteGroceryVariant(group_id: any, id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/variant/delete/` + group_id + '/' + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  GroceryvariantStatusUpdate(id: any, status: any) {
    let apiStatus = status == 0 ? 0 : 1;
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/variant/update-status/` + id, { status: apiStatus }).pipe(map(user => user));
  }


  // PlaformFees
  createFoodPlaFormFees(fees: any) {
    var formData = {
      'fees': fees
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/platformFees`, formData).pipe(map(user => {
      return user;
    }));
  }

  updateFoodPlaFormFees(id: any, fees: any) {
    var formData = {
      'fees': fees
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/platformFees/update/${id}`, formData).pipe(map(user => {
      return user;
    }));
  }

  deleteFoodPlatFormFees(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/platformFees/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }
  getFoodPlatFormFees() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/platformFees`).pipe(map(user => user));
  }


  createGroceryPlaFormFees(fees: any) {
    var formData = {
      'fees': fees
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/platformFees`, formData).pipe(map(user => {
      return user;
    }));
  }

  updateGroceryPlaFormFees(id: any, fees: any) {
    var formData = {
      'fees': fees
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/platformFees/update/${id}`, formData).pipe(map(user => {
      return user;
    }));
  }

  deleteGroceryPlatFormFees(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/platformFees/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }
  getGroceryPlatFormFees() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/platformFees`).pipe(map(user => user));
  }
  getGrocerylistbyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/restaurant/view-more/` + id).pipe(map(user => user));
  }

  // Grocery Profile
  updateGSTINGrocery(gstin: any) {
    var formData = {
      'gstin': gstin
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/setting/update-gstin`, formData).pipe(map(user => {
      return user;
    }));
  }

  groceryuploadImage(image: any) {
    const formData: FormData = new FormData();
    if (image) {
      formData.append('image', image, image.name);
    }
    return this.http.put<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/setting/uploadimage`, formData).pipe(map(user => {
      return user;
    }));
  }

  // grocery dashboard
  grocerydashboardChartdata(startDate: any, endDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/dashboard/daywisechartdata?startDate=` + startDate + '&endDate=' + endDate).pipe(map(user => {
      return user;
    }))
  }
  grocerydashboardPaymentCashNew(startDate: any, endDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/dashboard/paymentsTotalAll?startDate=` + startDate + '&endDate=' + endDate).pipe(map(user => {
      return user;
    }))
  }
  grocerydashboardCount() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/dashboard/`).pipe(map(user => {
      return user;
    }))
  }

  // grocery Invoice
  downloadGroceryDeliveryInvoice(fromDate: any, toDate: any) {
    const file = this.http.get<Blob>(`${environment.apiUrl}${environment.apiPrefix}/grocery/order/excel?fromDate=` + fromDate + '&toDate=' + toDate, { responseType: 'blob' as 'json' }).pipe(map(user => {
      return user
    }));
    return file;
  }

  groceryOpenStatus(status: any) {
    let apiStatus = status == 0 ? 0 : 1;
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/setting/updateOpenStatus`, { status: apiStatus }).pipe(map(user => user));
  }

  restaturantOpenStatus(status: any) {
    let apiStatus = status == 0 ? 0 : 1;
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/settings/updateOpenStatus`, { status: apiStatus }).pipe(map(user => user));
  }


  // Coupon
  restaturantcoupon(searchName: any, page: any, restaurantId: any, status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/coupon?searchName=` + searchName + '&restaurantId=' + restaurantId + '&page=' + page + '&status=' + status).pipe(map(user => {
      return user;
    }))
  }


  addrestaturantcoupon(coupon_code: any, title: any, value_type: any, value_amount: any, terms_condition: any, applicableamount_from: any, applicableamount_to: any, max_discount: any,
    from_date: any, to_date: any, from_time: any, to_time: any, days: any, user_limit: any, status: any
  ) {
    var formData = {
      'coupon_code': coupon_code,
      'title': title,
      'value_type': value_type,
      'value_amount': value_amount,
      'terms_conditions': terms_condition,
      'applicableamount_from': applicableamount_from,
      'applicableamount_to': applicableamount_to,
      'max_discount': max_discount,
      'from_date': from_date,
      'to_date': to_date,
      'from_time': from_time,
      'to_time': to_time,
      'days': days,
      'user_limit': user_limit,
      'status': status
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/coupon`, formData).pipe(map(user => {
      return user;
    }));
  }

  updaterestaturantcoupon(id: any, coupon_code: any, title: any, value_type: any, value_amount: any, terms_condition: any, applicableamount_from: any, applicableamount_to: any, max_discount: any,
    from_date: any, to_date: any, from_time: any, to_time: any, days: any, user_limit: any, status: any
  ) {
    var formData = {
      'coupon_code': coupon_code,
      'title': title,
      'value_type': value_type,
      'value_amount': value_amount,
      'terms_conditions': terms_condition,
      'applicableamount_from': applicableamount_from,
      'applicableamount_to': applicableamount_to,
      'max_discount': max_discount,
      'from_date': from_date,
      'to_date': to_date,
      'from_time': from_time,
      'to_time': to_time,
      'days': days,
      'user_limit': user_limit,
      'status': status
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/coupon/update/${id}`, formData).pipe(map(user => {
      return user;
    }));
  }

  deleterestaturantcoupon(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/coupon/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  restaturantcouponbyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/restaurant/coupon/view/` + id).pipe(map(user => user));
  }

  grocerycoupon(searchName: any, page: any, storeId: any, status: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/coupon?searchName=` + searchName + '&storeId=' + storeId + '&page=' + page + '&status=' + status).pipe(map(user => {
      return user;
    }))
  }


  addgrocerycoupon(coupon_code: any, title: any, value_type: any, value_amount: any, terms_condition: any, applicableamount_from: any, applicableamount_to: any, max_discount: any,
    from_date: any, to_date: any, from_time: any, to_time: any, days: any, user_limit: any, status: any
  ) {
    var formData = {
      'coupon_code': coupon_code,
      'title': title,
      'value_type': value_type,
      'value_amount': value_amount,
      'terms_conditions': terms_condition,
      'applicableamount_from': applicableamount_from,
      'applicableamount_to': applicableamount_to,
      'max_discount': max_discount,
      'from_date': from_date,
      'to_date': to_date,
      'from_time': from_time,
      'to_time': to_time,
      'days': days,
      'user_limit': user_limit,
      'status': status
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/coupon`, formData).pipe(map(user => {
      return user;
    }));
  }

  updategrocerycoupon(id: any, coupon_code: any, title: any, value_type: any, value_amount: any, terms_condition: any, applicableamount_from: any, applicableamount_to: any, max_discount: any,
    from_date: any, to_date: any, from_time: any, to_time: any, days: any, user_limit: any, status: any
  ) {
    var formData = {
      'coupon_code': coupon_code,
      'title': title,
      'value_type': value_type,
      'value_amount': value_amount,
      'terms_conditions': terms_condition,
      'applicableamount_from': applicableamount_from,
      'applicableamount_to': applicableamount_to,
      'max_discount': max_discount,
      'from_date': from_date,
      'to_date': to_date,
      'from_time': from_time,
      'to_time': to_time,
      'days': days,
      'user_limit': user_limit,
      'status': status
    }
    return this.http.patch<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/coupon/update/${id}`, formData).pipe(map(user => {
      return user;
    }));
  }

  deletegrocerycoupon(id: any) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/coupon/delete/` + id)
      .pipe(map((user) => {
        return user;
      }));
  }

  grocerycouponbyId(id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/grocery/coupon/view/` + id).pipe(map(user => user));
  }
  
}
